import { render, staticRenderFns } from "./activetemplateDetail.vue?vue&type=template&id=c6e6f8ca"
import script from "./activetemplateDetail.vue?vue&type=script&lang=js"
export * from "./activetemplateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports